<mat-icon class="mr-1">subject</mat-icon>
@if (searchTab.resultCount) {
  <span class="font-weight-bold">{{ searchTab.resultCount }}</span
  >
}: {{ searchTab.title }}

<button
  (click)="$event.preventDefault(); remove.emit(searchTab)"
  [id]="'catalog_result_btn_close-tab_' + index"
  mat-icon-button
>
  <mat-icon>close</mat-icon>
</button>
